import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { selectCourses } from "../../store/slices/courses/slice";
import { getCourses } from "../../store/slices/courses/asyncThunks";
import {
  FaPalette,
  FaCrown,
  FaGem,
  FaPhone,
  FaUserCircle,
  FaEnvelope,
  FaMapMarkerAlt,
  FaGraduationCap,
  FaInfoCircle,
  FaFileContract,
  FaShieldAlt,
  FaBlog,
  FaQuestionCircle,
  FaCreditCard,
} from "react-icons/fa";
import {
  FooterBottom,
  FooterContent,
  FooterSection,
  FooterContainer,
  Container,
  SocialLinks,
  ContactInfo,
  SocialLinkInsta,
  SocialLinkTiktok,
  SocialLinkEmail,
  Logo,
  PaymentAcceptIcon,
} from "./Footer.styles";

import LogoImg from "../../assets/images/logo-01.png";

const Footer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const courses = useSelector(selectCourses);

  useEffect(() => {
    if (courses.length === 0) {
      dispatch(getCourses());
    }
  }, [dispatch, courses.length]);

  const onNavigate = (path) => {
    navigate(path);
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 300);
  };

  return (
    <FooterContainer>
      <Container>
        <FooterContent>
          <FooterSection>
            <Logo src={LogoImg} alt="MITOVKA BeautySpot logo" />

            <SocialLinks>
              <SocialLinkInsta
                onClick={() => {
                  window.open(
                    "https://www.instagram.com/mm_beautyspot/",
                    "_blank",
                  );
                }}
              />

              <SocialLinkTiktok
                onClick={() => {
                  window.open("https://www.tiktok.com/@mitovm", "_blank");
                }}
              />

              <SocialLinkEmail
                onClick={() => {
                  const recipient = "info@mitovka.com";

                  const mailtoLink = `mailto:${recipient}`;
                  window.location.href = mailtoLink;
                }}
              />
            </SocialLinks>
          </FooterSection>

          <FooterSection>
            <h4>
              <FaPhone />
              Kontakt
            </h4>
            <div href="mailto:info@mitovka.com">
              <FaEnvelope />
              info@mitovka.com
            </div>

            <ContactInfo>
              <FaMapMarkerAlt />
              Novi Sad, Srbija
            </ContactInfo>
          </FooterSection>

          <FooterSection>
            <h4>
              <FaGraduationCap />
              Kursevi
            </h4>
            {courses.map((course, i) => (
              <div
                key={course.id}
                onClick={(e) => {
                  e.preventDefault();
                  onNavigate(`/kurs/${course.slug || course.id}`);
                }}
              >
                {i === 0 && <FaCrown />}
                {i === 1 && <FaPalette />}
                {i === 2 && <FaGem />}

                {course.title.split(" - ")[0]}
              </div>
            ))}
            <div
              onClick={(e) => {
                e.preventDefault();
                onNavigate("/kontakt");
              }}
            >
              <FaUserCircle />
              1:1 Sesije
            </div>
          </FooterSection>

          <FooterSection>
            <h4>
              <FaInfoCircle />
              Informacije
            </h4>
            <div
              onClick={(e) => {
                e.preventDefault();
                onNavigate("/uslovi-koriscenja");
              }}
            >
              <FaFileContract />
              Uslovi Korišćenja
            </div>
            <div
              onClick={(e) => {
                e.preventDefault();
                onNavigate("/politika-privatnosti");
              }}
            >
              <FaShieldAlt />
              Politika Privatnosti
            </div>
            <div
              onClick={(e) => {
                e.preventDefault();
                onNavigate("/cesta-pitanja");
              }}
            >
              <FaQuestionCircle />
              Česta Pitanja
            </div>
            <div
              onClick={(e) => {
                e.preventDefault();
                onNavigate("/o-meni");
              }}
            >
              <FaBlog />O Meni
            </div>
          </FooterSection>

          <FooterSection>
            <h4>
              <FaCreditCard />
              Plaćanje
            </h4>
            <PaymentAcceptIcon />
          </FooterSection>
        </FooterContent>

        <FooterBottom>
          <p>
            &copy; 2025 MITOVKA. Sva prava zadržana. Napravljeno sa ♡ za beauty
            edukaciju
          </p>
        </FooterBottom>
      </Container>
    </FooterContainer>
  );
};

export default Footer;
